import * as React from "react";
import { useState } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import { useEffect } from "react";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

import useEnroll from "../../../../hooks/UseEnroll";
import CustomButton from "../../CustomButton";

const ActionBtn = ({ about }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [enrollBtn, setEnrollBtn] = useState(false);

  const [handleEnrollBtn] = useEnroll(about?.pk, enrollBtn, setEnrollBtn);

  useEffect(() => {
    about && setEnrollBtn(about.enrolled);
  }, [about]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        mb: "24px",
        // justifyContent: "space-between",
        // maxWidth: "72px",
        // position: "absolute",
        // right: "15px",
        // top: "-40px",
      }}
    >
      <CustomButton
        title='Comment'
        onClick={() => navigate(`/table/${params.tableId}/comment`)}
        fSize='16px'
        width='100%'
        height='40px'
        bShadow='0px'
        bgColor='white.main'
        mRight='10px'
        icon1={<TextsmsOutlinedIcon />}
        icon2={about?.all_comments_count}
      />

      <CustomButton
        className='t-follow'
        title={enrollBtn ? "Followed" : "Follow"}
        onClick={handleEnrollBtn}
        fSize='16px'
        width='100%'
        height='40px'
        bShadow={enrollBtn ? "0px" : "2px"}
        bgColor={enrollBtn ? "black.main" : "primary.main"}
        color={enrollBtn ? "white.main" : "primary.main"}
        icon1={
          enrollBtn ? (
            <CheckCircleOutlineRoundedIcon />
          ) : (
            <AddCircleOutlineRoundedIcon />
          )
        }
        icon2={about?.spectators.length}
      />
      {/* <Box sx={{ pr: "8px" }}> */}
      {/* <CustomCircleButton
                width='32px'
                height='32px'
                onClick={handleShare}
                bgColor={
                  snackbarMode && snackbarTitle === "Table link copied!"
                    ? "black.main"
                    : "white.main"
                }
                color={
                  snackbarMode && snackbarTitle === "Table link copied!"
                    ? "white.main"
                    : "black.main"
                }
                bShadow={"none"}
                hoverColor={
                  snackbarMode && snackbarTitle === "Table link copied!"
                    ? "white.main"
                    : "black.main"
                }
                hoverBgColor={
                  snackbarMode && snackbarTitle === "Table link copied!"
                    ? "black.main"
                    : "white.main"
                }
                activeBgColor='black.main'
                activeColor='white.main'
                hoverBorder={
                  isMobile
                    ? `1.5px solid  ${theme.palette.black.main}`
                    : "1.5px solid transparent"
                }
              >
                <ShareOutlinedIcon sx={{ fontSize: "22px", pr: "1.5px" }} />
              </CustomCircleButton> */}
      {/* <CustomCircleButton
          onClick={() => navigate(`/table/${params.tableId}/comment/`)}
          width={"32px"}
          height={"32px"}
          bgColor='white.main'
          color='black.main'
          bShadow='none'
          border='2px solid'
          hoverBgColor='white.main'
          hoverColor='black.main'
          hoverBorder={`2px solid`}
          activeBgColor='black.main'
          activeColor='white.main'
        >
          <TextsmsOutlinedIcon
            sx={{
              fontSize: "22px",
              ml: "2px",
            }}
          />
          {about?.comments_count > 0 && (
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "danger.main",
                borderRadius: "50%",
                border: "1px solid white",
                position: "absolute",
                right: 0,
                top: 2,
              }}
            ></Box>
          )}
          <Typography
            sx={{
              fontSize: "10px",
              zIndex: 22,
              position: "absolute",
              right: "7px",
              bottom: "2px",
              padding: "2px 2px 0 2px",
              backgroundColor: "white.main",
              lineHeight: "11px",
            }}
          >
            {about?.comments_count}
          </Typography>
        </CustomCircleButton> */}
      {/* </Box> */}

      {/* <Box sx={{ pr: "1px" }}>
        <CustomCircleButton
          width='32px'
          height='32px'
          onClick={handleEnrollBtn}
          bgColor={enrollBtn ? "black.main" : "primary.main"}
          color={enrollBtn ? "white.main" : "black"}
          hoverBgColor='black.main'
          hoverColor='white.main'
          activeBgColor='black.main'
          activeColor='white.main'
          bShadow={
            enrollBtn ? "none" : `0px 2px 0px ${theme.palette.black.main}`
          }
        >
          {enrollBtn ? (
            <BookmarkAddedOutlinedIcon sx={{ fontSize: "22px" }} />
          ) : (
            <BookmarkBorderRoundedIcon sx={{ fontSize: "22px" }} />
          )}
        </CustomCircleButton>
      </Box> */}
    </Box>
  );
};
export default ActionBtn;
